var _circle, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTiktokIcon = function SvgTiktokIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6419 15.0844C27.5163 15.0844 26.4776 14.7115 25.6437 14.0824C24.6873 13.3612 24 12.3035 23.7573 11.0843C23.6969 10.783 23.6648 10.472 23.6615 10.1534H20.446V18.9396L20.4421 23.7522C20.4421 25.0388 19.6042 26.1298 18.4428 26.5134C18.1058 26.6248 17.7417 26.6775 17.3625 26.6567C16.8787 26.6302 16.4253 26.4841 16.0313 26.2484C15.1925 25.7469 14.6241 24.8369 14.6085 23.796C14.5843 22.1691 15.8995 20.8429 17.5251 20.8429C17.8461 20.8429 18.1542 20.8952 18.4428 20.9903V18.5891V17.7259C18.1384 17.6808 17.8288 17.6574 17.5155 17.6574C15.7361 17.6574 14.072 18.397 12.8823 19.7296C11.9832 20.7365 11.4439 22.0212 11.3607 23.3684C11.2517 25.1382 11.8992 26.8204 13.1552 28.0617C13.3396 28.244 13.5335 28.4131 13.7361 28.5691C14.8129 29.3973 16.1293 29.8466 17.5157 29.8466C17.8288 29.8466 18.1386 29.8234 18.443 29.7783C19.7382 29.5864 20.9331 28.9936 21.8762 28.0613C23.035 26.916 23.6753 25.3955 23.682 23.7771L23.6654 16.5905C24.2181 17.0169 24.8227 17.3699 25.4713 17.6436C26.4802 18.0692 27.55 18.285 28.6508 18.2847V15.95V15.0837C28.6517 15.0844 28.6425 15.0844 28.6419 15.0844Z",
    fill: "#312F30"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTiktokIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tiktok_icon.73820109.svg";
export { ForwardRef as ReactComponent };